import {
	CHANGE_DEVICE,
	INIT,
	SITE_INIT,
	OPEN_MENU,
	UPDATE_CART,
	SET_QUERY,
	REMOVE_NOTIFICATION,
	CHANGE_LANGUAGE,
	INDEX_SORT,
} from '../actions/environment';
import { setCookie } from '../utils/dom';
import { deepClone } from '../utils/object';
import { urlify } from '../utils/string';

export const initialState = {
	properties: {
		siteInitiated: false,
		siteUpdated: false,
	},
	setup: {},
	searchInputText: '',
	hashLocation: '',
	index: [],
	cart: {},
	indexSort: 'chronological',
	navigation: {
		open: false,
	},
	pagination: {},
};

const environment = (state = initialState, action) => {
	switch (action.type) {
		case INIT:
			return {
				...state,
				properties: {
					...state.properties,
					siteClosed: action.initData.siteClosed || false,
					siteInitiated: true,
				},
				setup: {
					...state.setup,
					...action.initData.setup,
				},
				header: {
					...state.header,
					...action.initData.header,
				},
				footer: {
					...state.footer,
					...action.initData.footer,
				},
				navigation: {
					...state.navigation,
					...action.initData.navigation,
				},
			};

		case CHANGE_DEVICE:
			return {
				...state,
				setup: {
					...state.setup,
					isMobile: action.isMobile,
				},
			};

		case 'SITE_UPDATED':
			return {
				...state,
				properties: {
					...state.properties,
					siteUpdated: true,
				},
			};

		case 'UPDATE_PAGINATION':
			return {
				...state,
				pagination: {
					...state.pagination,
					[action.currentPath]: action.currentPage,
				},
			};

		case 'UPDATE_HASH':
			return {
				...state,
				hashLocation: action.hash,
			};

		case 'PAGE_PATHS':
			return {
				...state,
				pageType: action.pageType,
				pagePaths: action.paths,
			};

		case SITE_INIT:
			return {
				...state,
				properties: {
					...state.properties,
					siteInitiated: true,
				},
			};

		case 'UPDATE_COUNTRY': {
			setCookie('settings', [state.setup.language, action.country, parseInt(action.market, 10), parseInt(action.pricelist, 10)]);
			const shippable = state.setup.countries[action.country].shipTo;
			return {
				...state,
				setup: {
					...state.setup,
					country: action.country,
					market: action.market,
					pricelist: action.pricelist,
					unableToSendToCountry: !shippable,
				},
			};
		}

		case CHANGE_LANGUAGE: {
			setCookie('settings', [action.language, state.setup.country, parseInt(state.setup.market, 10), parseInt(state.setup.pricelist, 10)]);
			return {
				...state,
				setup: {
					...state.setup,
					language: action.language,
				},
			};
		}

		case OPEN_MENU:
			return {
				...state,
				navigation: {
					...state.navigation,
					open: !state.navigation.open,
				},
			};

		case UPDATE_CART: {
			let removeItem = action.method === 'remove';
			if (action.method === 'decrease' && state.cart[action.item]) {
				if (state.cart[action.item] <= 1) removeItem = true;
				else {
					return {
						...state,
						cart: {
							...state.cart,
							[action.item]: state.cart[action.item] - 1,
						},
					};
				}
			}

			if (removeItem && state.cart[action.item]) {
				// removed variable not used and removed from object due to rest property.
				const { [action.item]: removed, ...cartState } = state.cart;
				return {
					...state,
					cart: cartState,
				};
			}

			if (action.method === 'set') {
				return {
					...state,
					cart: {
						...state.cart,
						[action.item]: action.amount,
					},
				};
			}

			// default increase item
			return {
				...state,
				cart: {
					...state.cart,
					[action.item]: state.cart[action.item] ? state.cart[action.item] + 1 : 1,
				},
			};
		}

		case SET_QUERY:
			return {
				...state,
				setup: {
					...state.setup,
					[action.key]: action.value,
				},
			};

		case REMOVE_NOTIFICATION:
			return {
				...state,
				header: {
					...state.header,
					[action.notificationType]: (
						state.header[action.notificationType].map((notification) => {
							if (urlify(notification.name) === action.notificationName) {
								return {
									...notification,
									removed: true,
								};
							}
							return notification;
						})
					),
				},
			};

		case 'SEARCH':
			return {
				...state,
				searchInputText: action.text,
			};

		case 'TOGGLE_FAVOURITE': {
			let favourites = [...state.favourites];
			const index = favourites.indexOf(action.productId);

			if (index === -1) {
				favourites = [...favourites, action.productId];
			} else {
				favourites = [...favourites.slice(0, index), ...favourites.slice(index + 1)];
			}

			localStorage.setItem('favourites', JSON.stringify(favourites));

			return {
				...state,
				favourites,
			};
		}

		case 'INDEX':
			return {
				...state,
				index: deepClone(action.index),
			};

		case INDEX_SORT:
			return {
				...state,
				indexSort: action.sortType === state.indexSort ? 'chronological' : action.sortType,
			};

		case 'UPDATE_FAVOURITES':
			return {
				...state,
				favourites: [...action.favourites],
			};

		default:
			return state;
	}
};

export default environment;
